import { useEffect } from 'react'

import { KeySet } from '../../../../types/utilities'
import { useContextMenuStoreApi } from '../hooks/useStore'
import { ContextMenuStore } from '../store/interface'

import { ContextMenuStoreUpdaterProps } from './interface'

const useStoreUpdater = <
  T,
  K extends KeySet<ContextMenuStore<T>> = KeySet<ContextMenuStore<T>>
>(
  key: K,
  value: ContextMenuStore<T>[K]
) => {
  const { setState } = useContextMenuStoreApi<T>()

  useEffect(() => {
    setState({ [key]: value })
  }, [key, value, setState])
}

export const ContextMenuStoreUpdater = <T>({
  offset,
  onClose,
  onOpen
}: ContextMenuStoreUpdaterProps<T>) => {
  useStoreUpdater('offset', offset)
  useStoreUpdater('onClose', onClose)
  useStoreUpdater<T>('onOpen', onOpen)

  return null
}
